import React from 'react';
import { CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell, CAlertLink, CTooltip, CButton, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilMap, cilOptions } from '@coreui/icons';
import { TableSkeleton } from '../SkeletonDetails';
import copiar from '../../../assets/brand/copia.png';
import copiadoImg from '../../../assets/brand/copiado.png';
import locationIcon from '../../../assets/brand/location.png';
import dataFrame from '../../../assets/brand/data-frame.png';
import { calculatePriorityResult, calculateAssignedCompany, getPriorityTheme } from './utils';
import EmptyState from './EmptyState';

import { getCategoryConfig, getCategoryByItem } from '../CategoryConfig';

const DetectionsTable = ({
    isLoading,
    dataProyecto,
    currentItems,
    lastViewedRowId,
    claseSeleccionada,
    handleOpenUnifiedDetail,
    handleVerImagen,
    setFocusMarkerId,
    setLastViewedRowId,
    focusOnCoordinate,
    handleCopyDireccion,
    copiedRow,
    handleOpenInGoogleMaps,
    mapFilter // Recibir mapFilter
}) => {
    if (isLoading || !dataProyecto) return <TableSkeleton />;

    const config = getCategoryConfig(mapFilter);

    return (
        <div className='contenedor-scroll-tabla-list bg-white rounded-3 shadow-sm border' style={{ height: '400px', overflowY: 'auto' }}>
            <CTable striped small align="middle" className="mb-0 ctable-list border-0" hover style={{ width: '100%' }}>
                <CTableHead className='sticky-header-detail' style={{ backgroundColor: '#f8f9fa' }}>
                    <CTableRow>
                        <CTableHeaderCell className='text-uppercase text-muted fw-bold border-bottom-0 py-3 ps-4' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>ID / Frame</CTableHeaderCell>
                        {config.hasPriority && <CTableHeaderCell className='text-uppercase text-muted fw-bold border-bottom-0 py-3' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Prioridad</CTableHeaderCell>}
                        <CTableHeaderCell className='text-uppercase text-muted fw-bold border-bottom-0 py-3' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Detección / Principal</CTableHeaderCell>
                        <CTableHeaderCell className='text-uppercase text-muted fw-bold border-bottom-0 py-3' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Dirección</CTableHeaderCell>
                        {config.hasCompany && <CTableHeaderCell className='text-uppercase text-muted fw-bold border-bottom-0 py-3' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Empresa</CTableHeaderCell>}
                        <CTableHeaderCell className='text-uppercase text-muted fw-bold border-bottom-0 py-3 text-center pe-4' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Acciones</CTableHeaderCell>
                    </CTableRow>
                </CTableHead>
                <CTableBody className='letra-contenido-3'>
                    {currentItems && currentItems.length > 0 ? (
                        currentItems.map((item, index) => {
                            const prioridad = calculatePriorityResult(item);
                            const theme = getPriorityTheme(prioridad);
                            const empresa = calculateAssignedCompany(item);

                            return (
                                <CTableRow
                                    key={index}
                                    className={`cursor-pointer align-middle transition-all ${lastViewedRowId === item.id ? 'row-viewed-highlight' : ''}`}
                                    onClick={() => handleOpenUnifiedDetail(item)}
                                >
                                    <CTableDataCell className="text-center fw-bold">
                                        <div className="d-flex flex-column align-items-center">
                                            <span className="text-primary">#{item.id}</span>
                                            <CAlertLink
                                                className="text-decoration-none small text-muted"
                                                style={{ fontSize: '0.65rem' }}
                                                onClick={(e) => { e.stopPropagation(); handleVerImagen(item.url_frame); }}
                                            >
                                                Frame #{item.id_frame}
                                            </CAlertLink>
                                        </div>
                                    </CTableDataCell>
                                    {(() => {
                                      const rowConfig = getCategoryByItem(item) || config;
                                      return rowConfig.hasPriority ? (
                                        <CTableDataCell>
                                            <span 
                                              className="badge shadow-sm" 
                                              style={{ 
                                                backgroundColor: theme.bg, 
                                                color: theme.color, 
                                                fontSize: '0.6rem',
                                                padding: '4px 8px',
                                                border: `1px solid ${theme.color}44`
                                              }}
                                            >
                                                {prioridad}
                                            </span>
                                        </CTableDataCell>
                                      ) : config.hasPriority ? <CTableDataCell /> : null; // Mantener celda vacía si la columna existe
                                    })()}
                                    <CTableDataCell>
                                        <div className="fw-semibold text-dark small">{item.tipo_especifico}</div>
                                        {(getCategoryByItem(item) || config).renderExtraInfo?.(item)}
                                    </CTableDataCell>
                                    <CTableDataCell className="small">
                                        <div className="text-truncate" style={{ maxWidth: '280px' }} title={item.direccion}>
                                            {item.direccion || 'N/A'}
                                        </div>
                                    </CTableDataCell>
                                    {(() => {
                                      const rowConfig = getCategoryByItem(item) || config;
                                      return rowConfig.hasCompany ? (
                                        <CTableDataCell>
                                            <span className="fw-bold text-secondary" style={{ fontSize: '0.7rem' }}>{empresa}</span>
                                        </CTableDataCell>
                                      ) : config.hasCompany ? <CTableDataCell /> : null;
                                    })()}
                                    <CTableDataCell>
                                        <div className="d-flex justify-content-center gap-1" onClick={(e) => e.stopPropagation()}>
                                            <CButton 
                                                color="info" size="sm" variant="ghost" className="p-1 btn-action-round-sm"
                                                title="Ver en Mapa"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setFocusMarkerId(item.id);
                                                    setLastViewedRowId(item.id);
                                                    const mapElement = document.querySelector('.grid-container .map-container');
                                                    if (mapElement) mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                                    setTimeout(() => focusOnCoordinate(item.latitud, item.longitud), 300);
                                                }}
                                            >
                                                <CIcon icon={cilMap} size="sm" />
                                            </CButton>
                                            <CButton className="btn-action-round-sm" onClick={() => handleCopyDireccion(item.direccion || '', index)} title="Copiar dirección">
                                                <img src={copiedRow === index ? copiadoImg : copiar} alt="Copy" width={14} />
                                            </CButton>
                                            {(item.latitud || item.longitud) && (
                                                <CButton className="btn-action-round-sm" onClick={() => handleOpenInGoogleMaps(item.latitud, item.longitud)} title="Google Maps">
                                                    <img src={locationIcon} alt="Map" width={14} />
                                                </CButton>
                                            )}
                                            <CButton className="btn-action-round-sm" onClick={() => handleOpenUnifiedDetail(item)} title="Detalles">
                                                <img src={dataFrame} alt="Info" width={14} />
                                            </CButton>
                                        </div>
                                    </CTableDataCell>
                                </CTableRow>
                            );
                        })
                    ) : (
                        <CTableRow>
                            <CTableDataCell colSpan={6} className="p-0">
                                <EmptyState
                                    type="no-results"
                                    title="Sin detecciones"
                                    message="No se encontraron detecciones con los filtros actuales. Intentá limpiar los filtros o cambiar la categoría."
                                />
                            </CTableDataCell>
                        </CTableRow>
                    )}
                </CTableBody>
            </CTable>
        </div>
    );
};

export default React.memo(DetectionsTable);
